module.exports = __webpack_public_path__ + "img/img_4.9f5a6deb.png";